import React, { useState } from "react";
import UploadImage from "./FileUpload";
import Datatable from "./Datatable";
import {ImageViewerAgenda} from "./Util";
import { COLUMNS_ESTUDENT, COLUMNS_CONTA_MONTO_DATES, COLUMNS_LIST_PERSON_CONTA } from "./DatatableColumns";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
} from "reactstrap";
import {urlMultimedia} from "./Services";
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import "react-datepicker/dist/react-datepicker.css";
import "./../../www/css/style.css";
import { SAVED_ICON,LOGOUT_ICON } from "./SrcImages";
import MultimediaUpload from "./MultimediaUpload";
import MultimediaUploadStudent from "./MultimediaUploadStudent";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import moment from "moment";

const override = css`
  margin: 0 auto;
  right: 15px;
  position: relative;
  top: 10px;
`;

const AdminAddAsignature = ({
  title,
  dataFAsignature,
  isOpen,
  toggle,
  toggleSave,
  onChange,
  setSubmateria,
  handling_sub,
  handleSub,
  as_motherName,
  msg_error,
  datArea,
  setArea,
}: any) => {
  const [ddOpenArea, setDdArea] = useState(false);
  const toggleDropdownArea = () => setDdArea((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{handling_sub ? "Agregar submateria" : title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={4}>
              <Label for="name">Areas: </Label>
            </Col>
            <Col xs={8}>
              <Dropdown isOpen={ddOpenArea} toggle={toggleDropdownArea} className="text-center">
                <DropdownToggle className="w-100" caret>
                  {dataFAsignature.ar_desc ? dataFAsignature.ar_desc : "Area"}
                </DropdownToggle>
                <DropdownMenu>
                  {datArea.map((data, i) => (
                    <DropdownItem onClick={() => setArea({ ar_id: data.ar_id, ar_desc: data.ar_desc })} key={data.ar_id}>
                      {data.ar_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col xs={4} className="mt-3">
              <Label for="name">Nombre : </Label>
            </Col>
            <Col xs={8} className="mt-3">
              <Form>
                <FormGroup>
                  <Input type="text" name="as_desc" onChange={onChange} defaultValue={dataFAsignature.as_desc} id="as_desc" placeholder="Nombre" />
                </FormGroup>
              </Form>
            </Col>
            <Col sm={12}>
              {handling_sub ? (
                <React.Fragment>
                  <Label>Materia principal: {as_motherName}</Label>
                </React.Fragment>
              ) : handleSub ? (
                <React.Fragment>
                  <Label>Tiene submateria:</Label>
                  <Button
                    outline
                    color="primary"
                    className="ml-2"
                    onClick={() => setSubmateria("1")}
                    active={dataFAsignature.as_sub === "1" ? true : false}
                  >
                    SI
                  </Button>
                  <Button
                    outline
                    color="danger"
                    className="ml-2"
                    onClick={() => setSubmateria("0")}
                    active={dataFAsignature.as_sub === "0" ? true : false}
                  >
                    NO
                  </Button>
                </React.Fragment>
              ) : null}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminModalAsignaturePlan = ({ title, materia, dataFmateria, setMateria, isOpen, toggle, toggleSave, msg_error }: any) => {
  const [ddOpenMateria, setDdMateria] = useState(false);
  const toggleDropdownMateria = () => setDdMateria((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={4} className="text-left">
              <Label className="lh-40">Materia: </Label>
            </Col>
            <Col sm={8}>
              <Dropdown isOpen={ddOpenMateria} toggle={toggleDropdownMateria} className="text-center">
                <DropdownToggle className="w-75" caret>
                  {dataFmateria.as_desc ? dataFmateria.as_desc : "Materia"}
                </DropdownToggle>
                <DropdownMenu>
                  {materia.map((data, i) => (
                    <DropdownItem onClick={() => setMateria({ as_id: data.as_id, as_desc: data.as_desc })} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label></Label>}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminHandlerPlans = ({ title, cycles, dataFplans, dataFcycle, setCycle, isOpen, toggle, toggleSave, onChange, msg_error }: any) => {
  const [ddOpenCycles, setDdCycles] = useState(false);
  const toggleDropdownCycles = () => setDdCycles((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={12}>
              <Form>
                <FormGroup>
                  <Label for="name">Plan: </Label>
                  <Input type="text" name="pl_desc" onChange={onChange} defaultValue={dataFplans.pl_desc} id="pl_desc" placeholder="Plan" />
                </FormGroup>
              </Form>
            </Col>
            <Col sm={4} className="text-left">
              <Label className="lh-40">Ciclos: </Label>
            </Col>
            <Col sm={8}>
              <Dropdown isOpen={ddOpenCycles} toggle={toggleDropdownCycles} className="text-center">
                <DropdownToggle className="w-75" caret>
                  {dataFcycle.cy_desc ? dataFcycle.cy_desc : "Tipo"}
                </DropdownToggle>
                <DropdownMenu>
                  {cycles.map((data, i) => (
                    <DropdownItem onClick={() => setCycle({ cy_id: data.cy_id, cy_desc: data.cy_desc })} key={data.cy_id}>
                      {data.cy_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label></Label>}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminHandleCycles = ({ title, dataFCycle, isOpen, toggle, toggleSave, onChange, msg_error }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="name">Ciclo: </Label>
            <Input type="text" name="cy_desc" onChange={onChange} defaultValue={dataFCycle.cy_desc} id="cy_desc" placeholder="Ciclo" />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col sm={12} className="text-right">
            {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
          </Col>
          <Col sm={12} className="text-right">
            <Button color="success" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button color="danger" onClick={toggle}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

const ChangePassword = ({ password, isOpen, toggle, toggleSave, onChange, setTypePerson }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Cambiar contraseña</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="name">Contraseña actual</Label>
            <Input type="text" name="per_password_actu" defaultValue={password} id="per_password_actu" placeholder="Contraseña actual" disabled />
          </FormGroup>
          <FormGroup>
            <Label for="name">Contraseña nueva</Label>
            <Input type="text" name="per_password" onChange={onChange} defaultValue="" id="per_password" placeholder="Contraseña nueva" />
          </FormGroup>
          <FormGroup>
            <Label for="name">Repetir contraseña</Label>
            <Input
              type="text"
              name="per_password_again"
              onChange={onChange}
              defaultValue=""
              id="per_password_again"
              placeholder="Repetir contraseña"
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button className="info" onClick={toggleSave}>
          Guardar
        </Button>{" "}
        <Button className="ok" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

const ChangeCelphone = ({ celphone, isOpen, toggle, toggleSave, onChange, msg_error }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cambiar celular</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Celular :</Label>
              <Input type="number" name="per_celphone1" onChange={onChange} defaultValue={celphone} id="per_celphone1" placeholder="Celular" />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Col sm={12} className="text-righ">
            {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label></Label>}
          </Col>
          <Button className="info" onClick={toggleSave}>
            Guardar
          </Button>{" "}
          <Button className="ok" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ChangeEmail = ({ email, isOpen, toggle, toggleSave, onChange, data, msg_error }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cambiar correo</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Correo actual</Label>
              <Input type="text" name="email_act" defaultValue={email} id="email_act" placeholder="Correo actual" disabled />
            </FormGroup>
            <FormGroup>
              <Label for="name">Correo nuevo</Label>
              <Input type="text" name="per_email" onChange={onChange} defaultValue="" id="per_email" placeholder="Correo nuevo" />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Col sm={12} className="text-righ">
            {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label></Label>}
          </Col>
          <Button className="info" onClick={toggleSave}>
            Guardar
          </Button>{" "}
          <Button className="ok" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ChangeImageAnnouncement = ({ isOpen, toggle, IMG_AVATAR, nameImg, urlHttp }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>Cambiar Avatar</ModalHeader>
        <ModalBody>
          <UploadImage nameImg={nameImg} IMG_AVATAR={IMG_AVATAR} urlHttp={urlHttp} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const ChangeAvatar = ({ isOpen, toggle, IMG_AVATAR, nameImg, urlHttp }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>Cambiar Avatar</ModalHeader>
        <ModalBody>
          <UploadImage nameImg={nameImg} IMG_AVATAR={IMG_AVATAR} urlHttp={urlHttp} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const UploadFile = ({ isOpen, toggle, IMG_AVATAR, nameImg, urlHttp,setNameFile }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>Postear multimedia</ModalHeader>
        <ModalBody>
          <MultimediaUpload nameImg={nameImg} IMG_AVATAR={IMG_AVATAR} urlHttp={urlHttp} setNameFile={setNameFile} />
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const PdfUploadModal = ({ title, isOpen, toggle, namePdf, setNameFile }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col className="text-center">
              <MultimediaUploadStudent namePdf={namePdf} setNameFile={setNameFile}/>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const PersonModal = ({
  title,
  dataTBlood,
  dataFTBlood,
  dataTPerson,
  dataFTPerson,
  dataFPerson,
  isOpen,
  toggle,
  toggleSave,
  onChange,
  setTypePerson,
  setSexo,
  setTypeBlood,
  onChangeDatePicker,
  msg_error,
}: any) => {
  const [ddOpenTypePerson, setDdTypePerson] = useState(false);
  const [ddOpenTypeBlood, setDdTypeBlood] = useState(false);

  const toggleDropdownTPerson = () => setDdTypePerson((prevState) => !prevState);
  const toggleDropdownTBlood = () => setDdTypeBlood((prevState) => !prevState);

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <Label for="name">Cedula</Label>
                  <Input
                    type="text"
                    name="per_cedula"
                    onChange={onChange}
                    defaultValue={dataFPerson.per_cedula}
                    id="per_cedula"
                    placeholder="Cedula"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Nombre</Label>
                  <Input type="text" name="per_name" onChange={onChange} defaultValue={dataFPerson.per_name} id="per_name" placeholder="Nombre" />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Apellido</Label>
                  <Input
                    type="text"
                    name="per_lastname"
                    onChange={onChange}
                    defaultValue={dataFPerson.per_lastname}
                    id="per_lastname"
                    placeholder="Apellido"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Correo</Label>
                  <Input type="text" name="per_email" onChange={onChange} defaultValue={dataFPerson.per_email} id="per_email" placeholder="Correo" />
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm={4} className="lh-40">
                      <Label for="name">Sexo:</Label>
                    </Col>
                    <Col sm={8} className="text-left">
                      <ButtonGroup>
                        <Button outline color="primary" onClick={() => setSexo("M")} active={dataFPerson.per_sex === "M" ? true : false}>
                          M
                        </Button>
                        <Button outline color="danger" onClick={() => setSexo("F")} active={dataFPerson.per_sex === "F" ? true : false}>
                          F
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm={4} className="lh-40">
                      <Label for="name">Sangre</Label>
                    </Col>
                    <Col sm={8} className="text-left">
                      <Dropdown isOpen={ddOpenTypeBlood} toggle={toggleDropdownTBlood}>
                        <DropdownToggle className="w-100" caret>
                          {dataFTBlood.tb_desc ? dataFTBlood.tb_desc : "Tipo de sangre"}
                        </DropdownToggle>
                        <DropdownMenu>
                          {dataTBlood.map((data, i) => (
                            <DropdownItem onClick={() => setTypeBlood(data.tb_desc, data.tb_id)} key={data.tb_id}>
                              {data.tb_desc}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="name">Telefono 1</Label>
                  <Input
                    type="text"
                    name="per_celphone1"
                    onChange={onChange}
                    defaultValue={dataFPerson.per_celphone1}
                    id="per_celphone1"
                    placeholder="Telefono 1"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Telefono 2</Label>
                  <Input
                    type="text"
                    name="per_celphone2"
                    onChange={onChange}
                    defaultValue={dataFPerson.per_celphone2}
                    id="per_celphone2"
                    placeholder="Telefono 2"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Nacimiento</Label>
                  <br></br>
                  <DatePicker
                    selected={new Date(dataFPerson.per_birthday)}
                    onChange={onChangeDatePicker}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control w-100"
                  />
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm={4} className="lh-40">
                      <Label for="name">Tipo</Label>
                    </Col>
                    <Col sm={8} className="text-left">
                      <Dropdown isOpen={ddOpenTypePerson} toggle={toggleDropdownTPerson}>
                        <DropdownToggle className="w-100" caret>
                          {dataFTPerson.typ_desc ? dataFTPerson.typ_desc : "Tipo"}
                        </DropdownToggle>
                        <DropdownMenu>
                          {dataTPerson.map((data, i) => (
                            <DropdownItem onClick={() => setTypePerson(data.typ_desc, data.typ_id)} key={data.typ_id}>
                              {data.typ_desc}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Label for="name">Otra informacion</Label>
                  <Input
                    type="textarea"
                    name="per_info"
                    rows="5"
                    onChange={onChange}
                    defaultValue={dataFPerson.per_info}
                    id="per_info"
                    placeholder="Otra informacion"
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminEditPassword = ({ data, isOpen, toggle, toggleSave, onChange }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Editar contraseña</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <Label for="name">Contraseña:</Label>
                <Input
                  type="text"
                  name="per_password"
                  onChange={onChange}
                  defaultValue={data.per_password}
                  id="per_password"
                  placeholder="Contraseña"
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col sm={12} className="text-right">
            <Button color="success" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button color="danger" onClick={toggle}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

const AnuncioModal = ({ title, data, isOpen, toggle, toggleSave, onChange, msg_error }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <Label for="name">Anuncio: </Label>
                <Input type="text" name="ad_desc" onChange={onChange} defaultValue={data.ad_desc} id="ad_desc" placeholder="Descripcion" />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col sm={12} className="text-right">
            {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
          </Col>
          <Col sm={12} className="text-right">
            <Button color="success" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button color="danger" onClick={toggle}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  </React.Fragment>
);

const GradesModal = ({ title, data, dataCycle, setCycle, isOpen, toggle, toggleSave, onChange, msg_error }: any) => {
  const [ddOpenCycle, setDdCycle] = useState(false);

  const toggleCycle = () => setDdCycle((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={12}>
                <FormGroup>
                  <Label for="name">Alias</Label>
                  <Input type="text" name="gr_alias" onChange={onChange} defaultValue={data.gr_alias} id="gr_alias" placeholder="Alias" />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Grado</Label>
                  <Input type="text" name="gr_desc" onChange={onChange} defaultValue={data.gr_desc} id="gr_desc" placeholder="Grado" />
                </FormGroup>
              </Col>
              <Col sm={4} className="lh-40">
                <Label for="name">Ciclo:</Label>
              </Col>
              <Col sm={8} className="text-left">
                <Dropdown isOpen={ddOpenCycle} toggle={toggleCycle}>
                  <DropdownToggle className="w-100" caret>
                    {data.cy_desc ? data.cy_desc : "Ciclo"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataCycle.map((item, i) => (
                      <DropdownItem onClick={() => setCycle(item.cy_id, item.cy_desc)} key={item.cy_id}>
                        {item.cy_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminModalRegistration = ({
  title,
  dataGradoSelected,
  propY,
  msg_error,
  msg_error2,
  dataEstName,
  dataAcName,
  isOpen,
  toggle,
  toggleSave,
  onChangeNewRegistration,
  setProcess,
  dataFRegistration,
  searchEstudent,
  searchAcu,
  setContract,
  setDataRegistration,
  isEditing,
  handlerOpenLista,
  handlerOpenListaAcudiente,
  handlerOpenPerson
}: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-registration">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={12} className="text-center">
                <Label className="font-weight-bold">{dataGradoSelected.gr_desc}</Label>
                <br></br>
                <Label className="font-weight-bold">{propY.set_registrationy}</Label>
              </Col>
              <Col sm={6}>
                <Row>
                  <Col sm={12} className="text-center">
                    <Label className="font-weight-bold">Estudiante</Label>
                  </Col>
                  <Col sm={9}>
                    <FormGroup>
                      <Label for="name">Cedula:</Label>
                      <Input
                        type="text"
                        name="reg_cedulaEst"
                        onKeyDown={searchEstudent}
                        onChange={onChangeNewRegistration}
                        defaultValue={dataFRegistration.reg_cedulaEst}
                        id="reg_cedulaEst"
                        placeholder="Cedula"
                        disabled={isEditing ? true : null}
                      />
                    </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <Button color="info" className="mr-2 button-pr" onClick={() => handlerOpenLista()}>
                        Lista
                      </Button>
                    </Col>
                    <Col sm={9}>
                    {msg_error.length > 0 ? <React.Fragment>
                      <Label className="l-color-danger">{msg_error}</Label>  
                      <Col sm={3}>
                      {/* <Button color="info" className="mr-2 button-pr" onClick={() => handlerOpenPerson()}>
                        Agregar nuevo
                      </Button> */}
                    </Col>
                    </React.Fragment> : <React.Fragment>
                    <Col sm={3}>
                      
                    </Col>
                    <Label>Nombre: </Label>
                    </React.Fragment> }
                    </Col>
                    
                    <Col sm={12}>
                    <FormGroup>
                    
                      <Input type="text" name="reg_nameEst" defaultValue={dataEstName.per_name} id="reg_nameEst" placeholder="Nombre" disabled />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <Col sm={6}>
                <Row>
                  <Col sm={12} className="text-center">
                    <Label className="font-weight-bold">Acudiente</Label>
                  </Col>
                  <Col sm={9}>
                    <FormGroup>
                      <Label for="name">Cedula:</Label>
                      <Input
                        type="text"
                        name="reg_cedulaAc"
                        onKeyDown={searchAcu}
                        onChange={onChangeNewRegistration}
                        defaultValue={dataFRegistration.reg_cedulaAc}
                        id="reg_cedulaAc"
                        placeholder="Cedula"
                      />
                    </FormGroup>
                    </Col>
                    <Col sm={3}>
                    <Button color="info" className="mr-2 button-pr" onClick={() => handlerOpenListaAcudiente()}>
                      Lista
                    </Button>
                    </Col>
                    <Col sm={12}>

                    <FormGroup>
                      {msg_error2.length > 0 ? <Label className="l-color-danger">{msg_error2}</Label> : <Label>Nombre: </Label>}
                      <Input type="text" name="reg_nameAc" value={dataAcName.per_name} id="reg_nameAc" placeholder="Nombre" disabled />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <Col sm={12} className="text-center mt-3">
                <Label className="font-weight-bold">Datos de matricula</Label>
              </Col>
              <Col sm={6}>
                <Row>
                  <Col sm={12} className="d-grid">
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_testpsico"
                          id="reg_testpsico"
                          defaultChecked={dataFRegistration.reg_testpsico}
                          onChange={setDataRegistration}
                        />{" "}
                        Prueba Psicologica
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_photo"
                          id="reg_photo"
                          defaultChecked={dataFRegistration.reg_photo}
                          onChange={setDataRegistration}
                        />{" "}
                        Fotos carnet
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_certnac"
                          id="reg_certnac"
                          defaultChecked={dataFRegistration.reg_certnac}
                          onChange={setDataRegistration}
                        />{" "}
                        Certificado de nacimiento
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_certsal"
                          id="reg_certsal"
                          defaultChecked={dataFRegistration.reg_certsal}
                          onChange={setDataRegistration}
                        />{" "}
                        Certficado de buena salud
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_vacuna"
                          id="reg_vacuna"
                          defaultChecked={dataFRegistration.reg_vacuna}
                          onChange={setDataRegistration}
                        />{" "}
                        Copia de tarjeta de vacunacion
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Label check>
                        <Input
                          type="checkbox"
                          name="reg_copyced"
                          id="reg_copyced"
                          defaultChecked={dataFRegistration.reg_copyced}
                          onChange={setDataRegistration}
                        />{" "}
                        Copia de cedula de acudiente
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col sm={12} className="text-center mt-3">
                    <Label className="font-weight-bold">¿Algun proceso legal?</Label>
                  </Col>
                  <Col sm={12} className="text-center mt-3">
                    <Row>
                      <Col sm={4}></Col>
                      <Col sm={4}>
                        <ButtonGroup className="w-100">
                          <Button
                            outline
                            color="primary"
                            onClick={() => setProcess("1")}
                            active={dataFRegistration.reg_plegal === "1" ? true : false}
                          >
                            SI
                          </Button>
                          <Button outline color="danger" onClick={() => setProcess("0")} active={dataFRegistration.reg_plegal === "0" ? true : false}>
                            NO
                          </Button>
                        </ButtonGroup>
                      </Col>
                      <Col sm={4}></Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12}>
                        <FormGroup>
                          <Input
                            type="textarea"
                            name="reg_legalinfo"
                            rows="5"
                            onChange={onChangeNewRegistration}
                            defaultValue={dataFRegistration.reg_legalinfo}
                            id="reg_legalinfo"
                            placeholder=""
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col sm={6}>
                <Row>
                  <Col sm={12} className="text-center">
                    <Label for="name" className="font-weight-bold">
                      Contrato educativo firmado
                    </Label>
                    <br></br>
                    <ButtonGroup>
                      <Button outline color="primary" onClick={() => setContract("1")} active={dataFRegistration.re_cfirmado === "1" ? true : false}>
                        SI
                      </Button>
                      <Button outline color="danger" onClick={() => setContract("0")} active={dataFRegistration.re_cfirmado === "0" ? true : false}>
                        NO
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 || msg_error2.length > 0 ? null : (
                <Button color="success" onClick={toggleSave}>
                  {isEditing ? "Guardar maticula" : "Registrar matricula"}
                </Button>
              )}

              <Button color="danger" className="ml-3" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalSaved = ({ isOpen,toggle }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} toggle={toggle}  className="modal-save">
      <ModalBody>
        <Form>
          <Row>
            <Col sm={12} className="text-center">
              <Label>Guardado</Label>
              <br></br>
              <img className="img-status img-search m-auto" src={SAVED_ICON} alt="" />
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  </React.Fragment>
);

const ModalSendingEmail = ({ isOpen, qty,total }: any) => (
  <React.Fragment>
    <Modal isOpen={isOpen} className="modal-save">
      <ModalBody>
        <Form>
          <Row>
            <Col sm={12} className="text-center">
              <Label className ="font-weight-bold">Enviando {qty}/{total}</Label>
              <br></br>
              <ClipLoader css={override} size={23} color={"#36D7B7"} loading={isOpen} />
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  </React.Fragment>
);

const AdminModalImport = ({
  dataGradeSelected,
  dataGrades,
  dataStuden,
  optionSelectRow,
  searchEstudent,
  setCeducativo,
  msg_error,
  onChangeImportRegistration,
  dataFRegistrationImport,
  isOpen,
  toggle,
  toggleSave,
  setGradeChanged,
}: // setPersonImport
any) => {
  const [ddOpenGrades, setDdGrades] = useState(false);
  const toggleDropdownGrades = () => setDdGrades((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl">
        <ModalHeader toggle={toggle}>Importar matricula</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={6}>
                <Label>Grado:</Label>
                <Dropdown isOpen={ddOpenGrades} toggle={toggleDropdownGrades}>
                  <DropdownToggle className="w-100" caret>
                    {dataGradeSelected.gr_desc ? dataGradeSelected.gr_desc : "Grados"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataGrades.map((data, i) => (
                      <DropdownItem onClick={() => setGradeChanged(data.gr_desc, data.gr_id)} key={data.gr_id}>
                        {data.gr_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                <Datatable
                  data={dataStuden}
                  columns={COLUMNS_ESTUDENT()}
                  keyProp="per_id"
                  exportD={false}
                  searchs={false}
                  selectRows={true}
                  optionSelectRow={optionSelectRow}
                />
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label for="name">Cedula:</Label>
                  <Input
                    type="text"
                    name="per_cedula"
                    onKeyDown={searchEstudent}
                    onChange={onChangeImportRegistration}
                    defaultValue={dataFRegistrationImport.per_cedula}
                    id="per_cedula"
                    placeholder="Cedula"
                  />
                </FormGroup>
                <FormGroup>
                  {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label>Nombre: </Label>}
                  <Input
                    type="text"
                    name="reg_nameEst"
                    defaultValue={dataFRegistrationImport.per_name}
                    id="reg_nameEst"
                    placeholder="Nombre"
                    disabled
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Grado: </Label>
                  <Input type="text" name="gr_desc" defaultValue={dataFRegistrationImport.gr_olddesc} id="gr_desc" placeholder="Grado" disabled />
                </FormGroup>
                <FormGroup>
                  <Label>Año cursado: </Label>
                  <Input
                    type="text"
                    name="reg_oldyear"
                    defaultValue={dataFRegistrationImport.reg_oldyear}
                    id="reg_oldyear"
                    placeholder="Año"
                    disabled
                  />
                </FormGroup>
                Contrato educativo firmado
                <br></br>
                <ButtonGroup>
                  <Button
                    outline
                    color="primary"
                    onClick={() => setCeducativo("1")}
                    active={dataFRegistrationImport.re_cfirmado === "1" ? true : false}
                  >
                    SI
                  </Button>
                  <Button
                    outline
                    color="danger"
                    onClick={() => setCeducativo("0")}
                    active={dataFRegistrationImport.re_cfirmado === "0" ? true : false}
                  >
                    NO
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminModalChangeGrade = ({ dataPersonSelected, dataGrades, isOpen, toggle, toggleSave, setGradeChanged }: any) => {
  const [ddOpenGrades, setDdGrades] = useState(false);
  const toggleDropdownGrades = () => setDdGrades((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cambiar entre grados</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={6} className="text-left">
                <Label className="lh-40">{`${dataPersonSelected.per_name} ${dataPersonSelected.per_lastname} ${dataPersonSelected.per_cedula}`}</Label>
              </Col>
              <Col sm={6} className="text-center">
                <Dropdown isOpen={ddOpenGrades} toggle={toggleDropdownGrades}>
                  <DropdownToggle className="w-100" caret>
                    {dataPersonSelected.gr_desc ? dataPersonSelected.gr_desc : "Grados"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataGrades.map((data, i) => (
                      <DropdownItem onClick={() => setGradeChanged(data.gr_desc, data.gr_id)} key={data.gr_id}>
                        {data.gr_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Cambiar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminModalRemoveStudent = ({ dataPersonSelected, isOpen, toggle, toggleConfirm, onChange, msg_error }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Retiro</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col sm={12} className="text-left">
                <Label className="lh-40">Estudiante : {`${dataPersonSelected.per_name} ${dataPersonSelected.per_lastname}`}</Label>
                <br></br>
                <Label className="lh-40">Cedula : {`${dataPersonSelected.per_cedula}`}</Label>
              </Col>
              <Col sm={12} className="text-center">
                <FormGroup>
                  <Label className="font-weight-bold">Motivo del retiro</Label>
                  <Input
                    type="textarea"
                    name="reg_reason"
                    rows="5"
                    onChange={onChange}
                    defaultValue={dataPersonSelected.per_reason}
                    id="reg_reason"
                    placeholder="Motivo..."
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleConfirm}>
                Confirmar retiro
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AdminAConsejeria = ({ title, dataTeacher, dataTeacherSelected, isOpen, toggle, toggleSave, setTeacher }: any) => {
  const [ddOpenTeacher, setDdTeacher] = useState(false);
  const toggleDropdownTeacher = () => setDdTeacher((prevState) => !prevState);

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Docente: </Label>
              <Dropdown isOpen={ddOpenTeacher} toggle={toggleDropdownTeacher} className="text-center">
                <DropdownToggle className="w-75" caret>
                  {dataTeacherSelected.per_name ? `Prof. ${dataTeacherSelected.per_name} ${dataTeacherSelected.per_lastname}` : "Profesor"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataTeacher.map((data, i) => (
                    <DropdownItem
                      onClick={() => setTeacher({ per_id: data.per_id, per_name: data.per_name, per_lastname: data.per_lastname })}
                      key={data.per_id}
                    >
                      {`Prof. ${data.per_name} ${data.per_lastname}`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const AsignarMateriaModal = ({
  title,
  dataAsig,
  dataGrade,
  dataForm,
  setAsignatura,
  setGrade,
  onChangeDatePickerStart,
  onChangeDatePickerEnd,
  isOpen,
  toggle,
  toggleSave,
  msg_error,
  setNullHour
}: any) => {
  const [ddOpenLunes, setDdLunes] = useState(false);
  const toggleDropdownLunes = () => setDdLunes((prevState) => !prevState);

  const [ddOpenLunesGr, setDdLunesGr] = useState(false);
  const toggleDropdownLunesGr = () => setDdLunesGr((prevState) => !prevState);

  const [ddOpenMartes, setDdMartes] = useState(false);
  const toggleDropdownMartes = () => setDdMartes((prevState) => !prevState);

  const [ddOpenMartesGr, setDdMartesGr] = useState(false);
  const toggleDropdownMartesGr = () => setDdMartesGr((prevState) => !prevState);

  const [ddOpenMiercoles, setDdMiercoles] = useState(false);
  const toggleDropdownMiercoles = () => setDdMiercoles((prevState) => !prevState);

  const [ddOpenMiercolesGr, setDdMiercolesGr] = useState(false);
  const toggleDropdownMiercolesGr = () => setDdMiercolesGr((prevState) => !prevState);

  const [ddOpenJueves, setDdJueves] = useState(false);
  const toggleDropdownJueves = () => setDdJueves((prevState) => !prevState);

  const [ddOpenJuevesGr, setDdJuevesGr] = useState(false);
  const toggleDropdownJuevesGr = () => setDdJuevesGr((prevState) => !prevState);

  const [ddOpenViernes, setDdViernes] = useState(false);
  const toggleDropdownViernes = () => setDdViernes((prevState) => !prevState);

  const [ddOpenViernesGr, setDdViernesGr] = useState(false);
  const toggleDropdownViernesGr = () => setDdViernesGr((prevState) => !prevState);

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={6}>
              <Label for="name">Hora inicio</Label>
              <br></br>
              <DatePicker
                selected={new Date(dataForm.tas_hourstar)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="Time"
                dateFormat="h:mm aa"
                onChange={onChangeDatePickerStart}
                minTime={setHours(setMinutes(new Date(), 0), 7)}
                maxTime={setHours(setMinutes(new Date(), 0), 14)}
                className="form-control w-100"
              />
            </Col>
            <Col sm={6}>
              <Label for="name">Hora final</Label>
              <br></br>
              <DatePicker
                selected={new Date(dataForm.tas_hourend)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="Time"
                dateFormat="h:mm aa"
                onChange={onChangeDatePickerEnd}
                minTime={setHours(setMinutes(new Date(), 0), 7)}
                maxTime={setHours(setMinutes(new Date(), 0), 14)}
                className="form-control w-100"
              />
            </Col>
            <Col sm={6}>
            <img className="img-status img-search p-relative-logout" onClick={() => setNullHour("1")} src={LOGOUT_ICON} alt="" />
              <Label for="name">Lunes</Label>
              <Dropdown isOpen={ddOpenLunes} toggle={toggleDropdownLunes}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_lunes ? dataForm.asdesc_lunes : "Materia lunes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_lunes", "asdesc_lunes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Dropdown className="mt-2 mb-3" isOpen={ddOpenLunesGr} toggle={toggleDropdownLunesGr}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.grdesc_lunes ? dataForm.grdesc_lunes : "Grado lunes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataGrade.map((data, i) => (
                    <DropdownItem onClick={() => setGrade(data.gr_id, data.gr_desc, "grid_lunes", "grdesc_lunes")} key={data.gr_id}>
                      {`${data.gr_desc} - (${data.gr_alias})`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <img className="img-status img-search p-relative-logout" onClick={() => setNullHour("2")} src={LOGOUT_ICON} alt="" />
              <Label for="name">Martes</Label>
              <Dropdown isOpen={ddOpenMartes} toggle={toggleDropdownMartes}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_martes ? dataForm.asdesc_martes : "Materia martes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_martes", "asdesc_martes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Dropdown className="mt-2 mb-3" isOpen={ddOpenMartesGr} toggle={toggleDropdownMartesGr}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.grdesc_martes ? dataForm.grdesc_martes : "Grado martes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataGrade.map((data, i) => (
                    <DropdownItem onClick={() => setGrade(data.gr_id, data.gr_desc, "grid_martes", "grdesc_martes")} key={data.gr_id}>
                      {`${data.gr_desc} - (${data.gr_alias})`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <img className="img-status img-search p-relative-logout" onClick={() => setNullHour("3")} src={LOGOUT_ICON} alt="" />
              <Label for="name">Miercoles</Label>
              <Dropdown isOpen={ddOpenMiercoles} toggle={toggleDropdownMiercoles}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_miercoles ? dataForm.asdesc_miercoles : "Materia miercoles"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_miercoles", "asdesc_miercoles")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Dropdown className="mt-2 mb-3" isOpen={ddOpenMiercolesGr} toggle={toggleDropdownMiercolesGr}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.grdesc_miercoles ? dataForm.grdesc_miercoles : "Grado miercoles"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataGrade.map((data, i) => (
                    <DropdownItem onClick={() => setGrade(data.gr_id, data.gr_desc, "grid_miercoles", "grdesc_miercoles")} key={data.gr_id}>
                      {`${data.gr_desc} - (${data.gr_alias})`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col sm={6}>
            <img className="img-status img-search p-relative-logout" onClick={() => setNullHour("4")} src={LOGOUT_ICON} alt="" />
              <Label for="name">Jueves</Label>
              <Dropdown isOpen={ddOpenJueves} toggle={toggleDropdownJueves}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_jueves ? dataForm.asdesc_jueves : "Materia jueves"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_jueves", "asdesc_jueves")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Dropdown className="mt-2 mb-3" isOpen={ddOpenJuevesGr} toggle={toggleDropdownJuevesGr}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.grdesc_jueves ? dataForm.grdesc_jueves : "Grado jueves"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataGrade.map((data, i) => (
                    <DropdownItem onClick={() => setGrade(data.gr_id, data.gr_desc, "grid_jueves", "grdesc_jueves")} key={data.gr_id}>
                      {`${data.gr_desc} - (${data.gr_alias})`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <img className="img-status img-search p-relative-logout" onClick={() => setNullHour("5")} src={LOGOUT_ICON} alt="" />
              <Label for="name">Viernes</Label>
              <Dropdown isOpen={ddOpenViernes} toggle={toggleDropdownViernes}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_viernes ? dataForm.asdesc_viernes : "Materia viernes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_viernes", "asdesc_viernes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Dropdown className="mt-2 mb-3" isOpen={ddOpenViernesGr} toggle={toggleDropdownViernesGr}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.grdesc_viernes ? dataForm.grdesc_viernes : "Grado viernes"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataGrade.map((data, i) => (
                    <DropdownItem onClick={() => setGrade(data.gr_id, data.gr_desc, "grid_viernes", "grdesc_viernes")} key={data.gr_id}>
                      {`${data.gr_desc} - (${data.gr_alias})`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const HorarioModal = ({
  title,
  dataAsig,
  dataForm,
  setAsignatura,
  onChangeDatePickerStart,
  onChangeDatePickerEnd,
  isOpen,
  toggle,
  toggleSave,
}: any) => {
  const [ddOpenLunes, setDdLunes] = useState(false);
  const toggleDropdownLunes = () => setDdLunes((prevState) => !prevState);

  const [ddOpenMartes, setDdMartes] = useState(false);
  const toggleDropdownMartes = () => setDdMartes((prevState) => !prevState);

  const [ddOpenMiercoles, setDdMiercoles] = useState(false);
  const toggleDropdownMiercoles = () => setDdMiercoles((prevState) => !prevState);

  const [ddOpenJueves, setDdJueves] = useState(false);
  const toggleDropdownJueves = () => setDdJueves((prevState) => !prevState);

  const [ddOpenViernes, setDdViernes] = useState(false);
  const toggleDropdownViernes = () => setDdViernes((prevState) => !prevState);

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={6}>
              <Label for="name">Hora inicio</Label>
              <br></br>
              <DatePicker
                selected={new Date(dataForm.hr_hourstart)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="Time"
                dateFormat="h:mm aa"
                onChange={onChangeDatePickerStart}
                minTime={setHours(setMinutes(new Date(), 0), 7)}
                maxTime={setHours(setMinutes(new Date(), 0), 14)}
                className="form-control w-100"
              />
            </Col>
            <Col sm={6}>
              <Label for="name">Hora final</Label>
              <br></br>
              <DatePicker
                selected={new Date(dataForm.hr_hourend)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="Time"
                dateFormat="h:mm aa"
                onChange={onChangeDatePickerEnd}
                minTime={setHours(setMinutes(new Date(), 0), 7)}
                maxTime={setHours(setMinutes(new Date(), 0), 14)}
                className="form-control w-100"
              />
            </Col>
            <Col sm={6}>
              <Label for="name">Lunes</Label>
              <Dropdown isOpen={ddOpenLunes} toggle={toggleDropdownLunes}>
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_lunes ? dataForm.asdesc_lunes : "Lunes"}
                </DropdownToggle>
                <DropdownMenu  className="scroll-drop">
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_lunes", "asdesc_lunes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Label for="name">Martes</Label>
              <Dropdown isOpen={ddOpenMartes} toggle={toggleDropdownMartes} >
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_martes ? dataForm.asdesc_martes : "Martes"}
                </DropdownToggle>
                <DropdownMenu className="scroll-drop">
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_martes", "asdesc_martes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Label for="name">Miercoles</Label>
              <Dropdown isOpen={ddOpenMiercoles} toggle={toggleDropdownMiercoles} >
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_miercoles ? dataForm.asdesc_miercoles : "Miercoles"}
                </DropdownToggle>
                <DropdownMenu className="scroll-drop">
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_miercoles", "asdesc_miercoles")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col sm={6}>
              <Label for="name">Jueves</Label>
              <Dropdown isOpen={ddOpenJueves} toggle={toggleDropdownJueves} >
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_jueves ? dataForm.asdesc_jueves : "Jueves"}
                </DropdownToggle>
                <DropdownMenu className="scroll-drop">
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_jueves", "asdesc_jueves")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              <Label for="name">Viernes</Label>
              <Dropdown isOpen={ddOpenViernes} toggle={toggleDropdownViernes} >
                <DropdownToggle className="w-100" caret>
                  {dataForm.asdesc_viernes ? dataForm.asdesc_viernes : "Viernes"}
                </DropdownToggle>
                <DropdownMenu className="scroll-drop">
                  {dataAsig.map((data, i) => (
                    <DropdownItem onClick={() => setAsignatura(data.as_id, data.as_desc, "asid_viernes", "asdesc_viernes")} key={data.as_id}>
                      {data.as_desc}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ContabilidadCuentasAddCuota = ({
  title,
  onChangeData,
  isOpen,
  toggle,
  toggleSave,
  formCobrarCuota,
  formMatricula,
  setCuotaEstado,
  setMoroStado,
  setMensualidad,
  dataMensualidad,
  msg_error
}: any) => {
  const [ddOpenViernes, setDdViernes] = useState(false);
  const toggleDropdownViernes = () => setDdViernes((prevState) => !prevState);
  var cxcmoro = 0;
  if (formCobrarCuota.cxc_morostado === "1") {
    if (moment(new Date(formCobrarCuota.mtd_date)) < moment(new Date().toString())) {
      if (Number(formCobrarCuota.cxc_saldo) > 0) {
        cxcmoro = Number(formCobrarCuota.cxc_saldo) * 0.1;
      } else {
        cxcmoro = Number(formMatricula.cxcr_mensualidad) * 0.1;
      }
    } else {
      cxcmoro = 0;
    }
  } else {
    cxcmoro = 0;
  }

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={3} className="text-left">
              <FormGroup>
                <Label className="font-weight-bold">Mensualidad:</Label>
                <Input
                  type="number"
                  name="cxc_mes"
                  rows="5"
                  onChange={onChangeData}
                  value={formMatricula.cxcr_mensualidad}
                  id="cxc_mes"
                  placeholder="B/."
                  disabled
                />
              </FormGroup>
              <Label for="name">Selecionar # mensualidad</Label>
              <Dropdown isOpen={ddOpenViernes} toggle={toggleDropdownViernes}>
                <DropdownToggle className="w-100" caret>
                  {formCobrarCuota.mtd_mes_number ? `mensualidad # ` + formCobrarCuota.mtd_mes_number : "Mensualidad"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataMensualidad.map((data, i) => (
                    <DropdownItem onClick={() => setMensualidad(data.mtd_id, data.mtd_mes_number, data.mtd_date)} key={data.mtd_id}>
                      {`mensualidad # ` + data.mtd_mes_number + ` (` + data.mtd_date + `)`}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col xs={3} className="lh-100px px-0 mx-0">
              <ButtonGroup>
                <Button color="primary" outline onClick={() => setCuotaEstado("1")} active={formCobrarCuota.cxc_stado === "1"}>
                  Debe
                </Button>
                <Button color="success" outline onClick={() => setCuotaEstado("2")} active={formCobrarCuota.cxc_stado === "2"}>
                  Pago
                </Button>
                <Button color="info" outline onClick={() => setCuotaEstado("3")} active={formCobrarCuota.cxc_stado === "3"}>
                  Saldo
                </Button>
              </ButtonGroup>
            </Col>
            <Col xs={3} className="text-left">
              <FormGroup>
                <Label className="font-weight-bold">Saldo:</Label>
                <Input
                  type="number"
                  name="cxc_saldo"
                  rows="5"
                  onChange={onChangeData}
                  defaultValue={formCobrarCuota.cxc_saldo}
                  id="cxc_saldo"
                  placeholder="B/."
                />
              </FormGroup>
              <FormGroup>
                <Label className="font-weight-bold">Morosidad:</Label>
                <Input
                  type="number"
                  name="cxc_moro"
                  rows="5"
                  onChange={onChangeData}
                  value={cxcmoro.toString()}
                  id="cxc_moro"
                  placeholder="B/."
                  disabled
                />
              </FormGroup>
            </Col>
            <Col xs={3}>
              <ButtonGroup className="na-p-relative">
                <Button color="primary" outline onClick={() => setMoroStado("1")} active={formCobrarCuota.cxc_morostado === "1"}>
                  Debe
                </Button>
                <Button color="success" outline onClick={() => setMoroStado("2")} active={formCobrarCuota.cxc_morostado === "2"}>
                  Pago
                </Button>
                <Button color="info" outline onClick={() => setMoroStado("4")} active={formCobrarCuota.cxc_morostado === "4"}>
                  N/A
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
          <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            {formMatricula.cxcr_mensualidad.length>0 ? (
            <Col sm={12} className="text-right">
            <Button color="success" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button color="danger" onClick={toggle}>
              Cancelar
            </Button>
          </Col>
            ):
            (
              <Col sm={12} className="text-right">
                  <Label className="l-color-danger">No tienes montos registrados a este grado</Label>
              </Col>
            )
            }

          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ContabilidadCuentasAddDetalle = ({
  title,
  onChangeData,
  isOpen,
  toggle,
  toggleSave,
  formDetalle,
  setTypeDetalle,
  setDetalleEstado,
  formMonto,
}: any) => {
  var monto = "0";
  if (formDetalle.cxcd_type === "1") {
    monto = formMonto.mt_plataforma;
  } else if (formDetalle.cxcd_type === "2") {
    monto = formMonto.mt_laboratorio;
  } else if (formDetalle.cxcd_type === "3") {
    monto = formMonto.mt_efisica;
  } else {
    monto = formMonto.mt_otro_monto;
  }

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={8} className="lh-80px">
              <ButtonGroup>
                <Button color="primary" outline onClick={() => setTypeDetalle("1", " Plataforma")} active={formDetalle.cxcd_type === "1"}>
                  Plataforma
                </Button>
                <Button color="success" outline onClick={() => setTypeDetalle("2", "Laboratorio")} active={formDetalle.cxcd_type === "2"}>
                  Laboratorio
                </Button>
                <Button color="info" outline onClick={() => setTypeDetalle("3", "Edu. Fisica")} active={formDetalle.cxcd_type === "3"}>
                  Edu. Fisica
                </Button>
                {formMonto.mt_otro_desc.length > 0 && (
                  <Button color="danger" outline onClick={() => setTypeDetalle("4", formMonto.mt_otro_desc)} active={formDetalle.cxcd_type === "4"}>
                    {formMonto.mt_otro_desc}
                  </Button>
                )}
              </ButtonGroup>
            </Col>
            <Col xs={4} className="text-left">
              <FormGroup>
                <Label className="font-weight-bold">Monto:</Label>
                <Input type="number" name="cxcd_monto" rows="5" onChange={onChangeData} value={monto} id="cxcd_monto" placeholder="B/." disabled />
              </FormGroup>
            </Col>
            <Col xs={8} className="text-left lh-80px">
              <ButtonGroup>
                <Button color="primary" outline onClick={() => setDetalleEstado("1")} active={formDetalle.cxcd_stado === "1"}>
                  Debe
                </Button>
                <Button color="success" outline onClick={() => setDetalleEstado("2")} active={formDetalle.cxcd_stado === "2"}>
                  Pago
                </Button>
                <Button color="info" outline onClick={() => setDetalleEstado("3")} active={formDetalle.cxcd_stado === "3"}>
                  Saldo
                </Button>
              </ButtonGroup>
            </Col>
            <Col xs={4} className="">
              <FormGroup>
                <Label className="font-weight-bold">Saldo:</Label>
                <Input
                  type="number"
                  name="cxcd_saldo"
                  rows="5"
                  onChange={onChangeData}
                  defaultValue={formDetalle.cxcd_saldo}
                  id="cxcd_saldo"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
          {formMonto.mt_plataforma.length>0 ? (
            <Col sm={12} className="text-right">
            <Button color="success" onClick={toggleSave}>
              Guardar
            </Button>{" "}
            <Button color="danger" onClick={toggle}>
              Cancelar
            </Button>
            </Col>
            ):
            (
              <Col sm={12} className="text-right">
                  <Label className="l-color-danger">No tienes montos registrados a este grado</Label>
              </Col>
            )
            }
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalMontos = ({
  title,
  formGrade,
  dataFMonto,
  dataMontoDates,
  dataFormMontoDates,
  onChange,
  onChangeMontoDates,
  isOpen,
  toggle,
  toggleSave,
  msg_error,
  saveMontoFechas,
  columnModalEditDates,
  loading,
}: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody className="padd-3">
          <Row>
            <Col className="text-center">
              <h4 className="font-weight-bold">{formGrade.gr_desc}</h4>
            </Col>
          </Row>
          <Row>
            <Col className="text-left" xs={2}>
              <Label className="font-weight-bold">Matricula: </Label>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Regular: </Label>
                <Input
                  type="number"
                  name="mt_matricula_r"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_matricula_r}
                  id="mt_matricula_r"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Hermano Menor: </Label>
                <Input
                  type="number"
                  name="mt_matricula_hm"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_matricula_hm}
                  id="mt_matricula_hm"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={4}>
              <FormGroup>
                <Label className="font-weight-bold">Hijo de docente: </Label>
                <Input
                  type="number"
                  name="mt_matricula_hd"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_matricula_hd}
                  id="mt_matricula_hd"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={2}>
              <Label className="font-weight-bold">Mensualidad: </Label>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Regular: </Label>
                <Input
                  type="number"
                  name="mt_mensualidad_r"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_mensualidad_r}
                  id="mt_mensualidad_r"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Hermano Menor: </Label>
                <Input
                  type="number"
                  name="mt_mensualidad_hm"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_mensualidad_hm}
                  id="mt_mensualidad_hm"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={4}>
              <FormGroup>
                <Label className="font-weight-bold">Hijo de docente: </Label>
                <Input
                  type="number"
                  name="mt_mensualidad_hd"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_mensualidad_hd}
                  id="mt_mensualidad_hd"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left mt-3" xs={2}>
              <Label className="font-weight-bold">Plataforma: </Label>
            </Col>
            <Col className="text-center mt-3" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_plataforma"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_plataforma}
                  id="mt_plataforma"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center mt-3" xs={7}></Col>
            <Col className="text-left mt-3" xs={2}>
              <Label className="font-weight-bold">Robotica: </Label>
            </Col>
            <Col className="text-center mt-3" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_robotica"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_robotica}
                  id="mt_robotica"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center mt-3" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Laboratorio: </Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_laboratorio"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_laboratorio}
                  id="mt_laboratorio"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Educacion Fisica</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input type="number" name="mt_efisica" onChange={onChange} defaultValue={dataFMonto.mt_efisica} id="mt_efisica" placeholder="B/." />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Otro Pago</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_otro_monto"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_otro_monto}
                  id="mt_otro_monto"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={3}>
              <Label className="font-weight-bold">Descripcion del pago:</Label>
            </Col>
            <Col className="text-center" xs={4}>
              <FormGroup>
                <Input
                  type="text"
                  name="mt_otro_desc"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_otro_desc}
                  id="mt_otro_desc"
                  placeholder="Descripcion"
                />
              </FormGroup>
            </Col>
            <Col xs={1}></Col>
          </Row>

          <Row className="border-top-solid">
            <Col className="text-left" xs={2}>
              <Label className="font-weight-bold">Pago Anualidad: </Label>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Regular: </Label>
                <Input
                  type="number"
                  name="mt_anualidad_r"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_anualidad_r}
                  id="mt_anualidad_r"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={3}>
              <FormGroup>
                <Label className="font-weight-bold">Hermano Menor: </Label>
                <Input
                  type="number"
                  name="mt_anualidad_hm"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_anualidad_hm}
                  id="mt_anualidad_hm"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left" xs={4}>
              <FormGroup>
                <Label className="font-weight-bold">Hijo de docente: </Label>
                <Input
                  type="number"
                  name="mt_anualidad_hd"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_anualidad_hd}
                  id="mt_anualidad_hd"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Plataforma:</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_a_plataforma"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_a_plataforma}
                  id="mt_a_plataforma"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Laboratorio:</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_a_laboratorio"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_a_laboratorio}
                  id="mt_a_laboratorio"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Robotica:</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_a_robotica"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_a_robotica}
                  id="mt_a_robotica"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-center" xs={7}></Col>
            <Col className="text-left " xs={2}>
              <Label className="font-weight-bold">Educacion Fisica:</Label>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <Input
                  type="number"
                  name="mt_a_efisica"
                  onChange={onChange}
                  defaultValue={dataFMonto.mt_a_efisica}
                  id="mt_a_efisica"
                  placeholder="B/."
                />
              </FormGroup>
            </Col>
            <Col className="text-right" xs={7}>
              <ClipLoader css={override} size={23} color={"#36D7B7"} loading={loading} />
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
            </Col>
          </Row>
          <Row>
            <Col className="text-center" xs={12}>
              <h4 className="font-weight-bold">Fechas</h4>
            </Col>
            <Col className="text-center" xs={3}>
              <FormGroup>
                <DatePicker
                  selected={moment(new Date(dataFormMontoDates.mtd_date)).toDate()}
                  onChange={onChangeMontoDates}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control w-100"
                />
              </FormGroup>
            </Col>
            <Col className="text-right" xs={9}>
              {dataFormMontoDates.mtd_id.length > 0 ? (
                <Button color="danger" onClick={saveMontoFechas}>
                  Actualizar fecha
                </Button>
              ) : (
                <Button color="success" onClick={saveMontoFechas}>
                  Agregar fecha
                </Button>
              )}
            </Col>
            <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : <Label> </Label>}
            </Col>
            <Col className="text-left" xs={12}>
              <Datatable
                data={dataMontoDates}
                columns={COLUMNS_CONTA_MONTO_DATES(columnModalEditDates)}
                keyProp="mtd_id"
                exportD={false}
                searchs={false}
                selectRows={false}
                optionSelectRow={null}
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const ModalEditSchedule = ({
  dataTasignature,
  dataGroup,
  dataAsig,
  dataFSchedule,
  setGroup,
  setAsign,
  setTypeAsign,
  setRequireFile,
  onChangeDesc,
  onChangeDatePicker,
  toggleSave,
  toggle,
  toggleClose,
  isOpen,
  title,
}: any) => {
  const [ddOpenGroupM, setDdGroupM] = useState(false);
  const toggleDropdownGroupM = () => setDdGroupM((prevState) => !prevState);
  const [ddOpenGradeM, setDdGradeM] = useState(false);
  const toggleDropdownGradeM = () => setDdGradeM((prevState) => !prevState);
  const [ddOpenTipoAM, setDdTaM] = useState(false);
  const toggleDropdownTipoAM = () => setDdTaM((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggleClose}>
        <ModalHeader toggle={toggleClose}>{title}</ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Row>
              <Col xs={5} sm={2} className="mt-3">
                <Label className="font-weight-bold">Fecha: </Label>
              </Col>
              <Col xs={7} sm={4} className="mt-3 input-schedule-date pm-unset">
              {/* className="float-center w-100"
              selected={new Date(dataFSchedule.di_date)}
              onChange={onChangeDatePicker}
              minDate={new Date()}
              maxDate={d.setMonth(d.getMonth() + 8)}
              showDisabledMonthNavigation */}
                <DatePicker
                  className="input-p-relative"
                  selected={moment(dataFSchedule.di_date).toDate()}
                  onChange={onChangeDatePicker}
                  showDisabledMonthNavigation
                />
              </Col>
              <Col sm={2} xs={5} className="text-left">
                <Label className="lh-40 font-weight-bold">Grupo: </Label>
              </Col>
              <Col xs={7} sm={4}>
                <Dropdown
                  isOpen={ddOpenGroupM}
                  toggle={toggleDropdownGroupM}
                  className="text-center"
                  disabled={dataFSchedule.di_preescolar === "1" ? true : false}
                >
                  <DropdownToggle className="w-100 column-dark" caret>
                    {dataFSchedule.gr_desc ? dataFSchedule.gr_desc : "Grupo"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataGroup.map((data, i) => (
                      <DropdownItem onClick={() => setGroup({ gr_id: data.gr_id, gr_desc: data.gr_desc, fetch: false,gr_literal:data.gr_literal })} key={data.gr_id}>
                        {data.gr_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col xs={5} sm={2} className="text-left">
                <Label className="lh-40 font-weight-bold">Tipo : </Label>
              </Col>
              <Col xs={7} sm={4}>
                <Dropdown
                  isOpen={ddOpenTipoAM}
                  toggle={toggleDropdownTipoAM}
                  className="text-center"
                  disabled={dataFSchedule.di_preescolar === "1" ? true : false}
                >
                  <DropdownToggle className="w-100 column-dark" caret>
                    {dataFSchedule.ta_desc ? dataFSchedule.ta_desc : "Tipo"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataTasignature.map((data, i) => (
                      <DropdownItem onClick={() => setTypeAsign({ ta_id: data.ta_id, ta_desc: data.ta_desc })} key={data.ta_id}>
                        {data.ta_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>

            <Row>
              <Col xs={5} sm={2} className="text-left">
                <Label className="lh-40 font-weight-bold">Materia: </Label>
              </Col>
              <Col xs={7} sm={4}>
                <Dropdown
                  isOpen={ddOpenGradeM}
                  toggle={toggleDropdownGradeM}
                  className="text-center"
                  disabled={dataFSchedule.di_preescolar === "1" ? true : false}
                >
                  <DropdownToggle className="w-100 column-dark" caret>
                    {dataFSchedule.as_desc ? dataFSchedule.as_desc : "Materia"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataAsig.map((data, i) => (
                      <DropdownItem onClick={() => setAsign({ as_id: data.as_id, as_desc: data.as_desc })} key={data.as_id}>
                        {data.as_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col xs={8} sm={2} className="text-left">
                <Label className="agenda-label-position font-weight-bold">Requiere archivos:</Label>
              </Col>
              <Col xs={4} sm={4} className="mt-1 btn-agenda-edit">
                <ButtonGroup className="float-right">
                  <Button
                    className="ml-4 warning"
                    onClick={() => setRequireFile({ di_alowfile: "1" })}
                    active={dataFSchedule.di_alowfile === "1" ? true : false}
                  >
                    SI
                  </Button>
                  <Button
                    className="ok"
                    onClick={() => setRequireFile({ di_alowfile: "0" })}
                    active={dataFSchedule.di_alowfile === "0" ? true : false}
                  >
                    NO
                  </Button>
                </ButtonGroup>
              </Col>
              <Col xs={12} sm={12} className="text-left mt-3">
                <Label className="font-weight-bold">Escriba la descripcion de la asignacion:</Label>
              </Col>
              <Col xs={12}>
                <FormGroup>
                  <Input
                    type="textarea"
                    name="di_desc"
                    rows="5"
                    onChange={onChangeDesc}
                    defaultValue={dataFSchedule.di_desc}
                    id="di_desc"
                    placeholder="Coloque aqui la descripción de la asignación a realizar"
                  />
                </FormGroup>
              </Col>
            </Row>
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button className="ok" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button className="info" onClick={toggleClose}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalListaPersonConta = ({ dataPerson, setPerson, toggleClose, isOpen, title,dataFGrade,dataGroup,setGroup }: any) => {
  const [ddOpenGroupM, setDdGroupM] = useState(false);
  const toggleDropdownGroupM = () => setDdGroupM((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggleClose}>
        <ModalHeader toggle={toggleClose}>{title}</ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Row>
              <Col xs={6}>
              <Label className="font-weight-bold">Selecione el grado:</Label>
              </Col>
              <Col xs={6}>
              <Dropdown
                  isOpen={ddOpenGroupM}
                  toggle={toggleDropdownGroupM}
                  className="text-center"
                  // disabled={dataFSchedule.di_preescolar === "1" ? true : false}
                >
                  <DropdownToggle className="w-100 column-dark" caret>
                    {dataFGrade.gr_desc ? dataFGrade.gr_desc : "Grupo"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {dataGroup.map((data, i) => (
                      <DropdownItem onClick={() => setGroup({ gr_id: data.gr_id, gr_desc: data.gr_desc,gr_alias:data.gr_alias})} key={data.gr_id}>
                        {data.gr_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col xs={12}>
              <Datatable
              data={dataPerson}
              columns={COLUMNS_LIST_PERSON_CONTA(setPerson)}
              keyProp="per_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
              </Col>
            </Row>
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="danger" onClick={toggleClose}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalAddCXC = ({ dataFMatricula,onChange,msg_error,toggleSave, toggleClose, isOpen, title,t_pago }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggleClose}>
        <ModalHeader toggle={toggleClose}>{title}</ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Row>
              <Col xs={4}>
              </Col>
              <Col xs={4}>
              <FormGroup>
                  <Input
                    type="text"
                    name="rpd_monto"
                    onChange={(e) => {onChange(e,t_pago)}}
                    defaultValue={dataFMatricula.rpd_monto}
                    id="rpd_monto"
                    placeholder="B/."
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
              </Col>
            </Row>
          
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <Row>
          <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggleClose}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};


const ModalAddMatricula = ({ dataFMatricula,onChange,msg_error,toggleSave, toggleClose, isOpen, title }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggleClose}>
        <ModalHeader toggle={toggleClose}>{title}</ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Row>
              <Col xs={4}>
              </Col>
              <Col xs={4}>
              <FormGroup>
                  <Input
                    type="text"
                    name="rpd_monto"
                    onChange={(e) => {onChange(e,"2")}}
                    defaultValue={dataFMatricula.rpd_monto}
                    id="rpd_monto"
                    placeholder="B/."
                  />
                </FormGroup>
              </Col>
              <Col xs={4}>
              </Col>
            </Row>
          
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <Row>
          <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggleClose}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalListaPerson = ({ dataPerson, setPerson, toggleClose, isOpen, title }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggleClose}>
        <ModalHeader toggle={toggleClose}>{title}</ModalHeader>
        <ModalBody>
          <React.Fragment>
            <Datatable
              data={dataPerson}
              columns={COLUMNS_LIST_PERSON_CONTA(setPerson)}
              keyProp="per_id"
              exportD={false}
              searchs={true}
              selectRows={false}
              optionSelectRow={null}
            />
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="danger" onClick={toggleClose}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalAPagos = ({ title, onChangeData, isOpen, toggle, toggleSave, setAPago, formAPago }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xl modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={12} className="text-left">
              <FormGroup>
                <Label className="font-weight-bold">Arreglo de pago:</Label>
                <Input
                  type="textarea"
                  name="ap_desc"
                  rows="5"
                  onChange={onChangeData}
                  defaultValue={formAPago.ap_desc}
                  id="ap_desc"
                  placeholder="Coloque aqui la descripción del arreglo de pago"
                />
              </FormGroup>
            </Col>
            <Col xs={12}>
              <ButtonGroup>
                <Button outline color="primary" onClick={() => setAPago("1")} active={formAPago.ap_active === "1" ? true : false}>
                  SI
                </Button>
                <Button outline color="danger" onClick={() => setAPago("0")} active={formAPago.ap_active === "0" ? true : false}>
                  NO
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalACycle = ({ title, onChangeData, isOpen, toggle, toggleSave, setOrden, dataOrden, dataFACycle, msg_error, setDigitoType }: any) => {
  const [ddOpenOrden, setDdOrden] = useState(false);
  const toggleDropdownOrden = () => setDdOrden((prevState) => !prevState);
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={5} className="text-left">
              <Label className="lh-40 font-weight-bold">Orden en el boletin: </Label>
            </Col>
            <Col xs={7}>
              <Dropdown isOpen={ddOpenOrden} toggle={toggleDropdownOrden} className="text-center">
                <DropdownToggle className="w-100" caret>
                  {dataFACycle.ar_sort ? dataFACycle.ar_sort : "Orden"}
                </DropdownToggle>
                <DropdownMenu>
                  {dataOrden.map((data, i) => (
                    <DropdownItem onClick={() => setOrden({ ar_sort: data.ar_sort })} key={data.ar_id}>
                      {data.ar_sort}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col xs={12} className="text-left">
              <FormGroup>
                <Label className="font-weight-bold">Area:</Label>
                <Input
                  type="textarea"
                  name="ar_desc"
                  rows="5"
                  onChange={onChangeData}
                  defaultValue={dataFACycle.ar_desc}
                  id="ar_desc"
                  placeholder="Coloque aqui la descripción del area"
                />
              </FormGroup>
            </Col>
            <Col xs={12}>
              <ButtonGroup>
                <Button outline color="primary" onClick={() => setDigitoType("0")} active={dataFACycle.ar_literal === "0" ? true : false}>
                  Usa digito
                </Button>
                <Button outline color="danger" onClick={() => setDigitoType("1")} active={dataFACycle.ar_literal === "1" ? true : false}>
                  Usa Literal
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalAddComent = ({ title,  isOpen, toggle, onChange,toggleSave, dataFomComment }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={12}>
            <Label> Comentario para :  
{
   dataFomComment.per_name
}
            </Label>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Input
                  type="textarea"
                  name="not_comment"
                  rows="5"
                  onChange={onChange}
                  defaultValue={dataFomComment.not_comment}
                  id="not_comment"
                  placeholder="Coloque aqui el comentario"
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const ModalLinkPersonal = ({ title, onChange, isOpen, toggle, toggleSave, dataFTeacher, msg_error }: any) => {
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs modal-content">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs={12} className="text-center">
              <Label className="lh-40 font-weight-bold">{dataFTeacher.per_name}</Label>
            </Col>
            <Col xs={12}>
              <FormGroup>
                <Label className="font-weight-bold">Link personal:</Label>
                <Input
                  type="textarea"
                  name="per_link"
                  rows="5"
                  onChange={onChange}
                  defaultValue={dataFTeacher.per_link}
                  id="per_link"
                  placeholder="Coloque aqui el link personal del teacher"
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col xs={12} className="text-right">
              {msg_error.length > 0 ? <Label className="l-color-danger">{msg_error}</Label> : null}
            </Col>
            <Col sm={12} className="text-right">
              <Button color="success" onClick={toggleSave}>
                Guardar
              </Button>{" "}
              <Button color="danger" onClick={toggle}>
                Cancelar
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const FILES_EXPLORER = ({ title, isOpen, toggle, filesObj }: any) => {

  var i;
  var count =0;
  for (i = 0; i < filesObj.length; i++) {
    if(filesObj[i].up_file_name.includes(".jpeg") || filesObj[i].up_file_name.includes(".png") || filesObj[i].up_file_name.includes(".jpg")){
      count= count+1;
    }
  }
  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={toggle} className="modal-xs">
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
          <Col xs={5}>
            </Col>
            <Col  xs={2} className="text-center m-auto">
            <React.Fragment>
              {
                count>0? <ImageViewerAgenda ad_img={filesObj}/>: null
              }    
              </React.Fragment>
            </Col>
            <Col xs={5}>
            </Col>
            <Col  xs={12} className="text-center mb-4">
            {filesObj.map((files, r) => {
              if(files.up_file_name.includes(".rar") || files.up_file_name.includes(".zip") || files.up_file_name.includes(".doc") || files.up_file_name.includes(".docx") || files.up_file_name.includes(".pdf") || files.up_file_name.includes(".mp4")){

                return <React.Fragment key={r*r}>
<a
                className="label-download-file-libreta"
                target="_blank"
                rel="noopener noreferrer"
                href={
                  urlMultimedia +
                  files.not_person +
                  "/" +
                  files.up_file_name
                }
                download
                key={r}
              >
                {files.up_file_name}
              </a>
              <br></br>
                </React.Fragment> 
              }
              return null
            })}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export {
  ModalSendingEmail,
  ModalAddCXC,
  ModalAddMatricula,
  ModalListaPersonConta,
  FILES_EXPLORER,
  ModalLinkPersonal,
  ModalACycle,
  ModalAPagos,
  ModalListaPerson,
  ModalEditSchedule,
  ModalMontos,
  AnuncioModal,
  ChangePassword,
  ChangeEmail,
  ChangeAvatar,
  ChangeImageAnnouncement,
  PersonModal,
  AdminEditPassword,
  GradesModal,
  AdminModalRegistration,
  AdminModalImport,
  AdminModalChangeGrade,
  AdminModalRemoveStudent,
  ModalSaved,
  AdminHandleCycles,
  AdminHandlerPlans,
  AdminAConsejeria,
  AdminAddAsignature,
  HorarioModal,
  ContabilidadCuentasAddCuota,
  ContabilidadCuentasAddDetalle,
  PdfUploadModal,
  ChangeCelphone,
  AsignarMateriaModal,
  AdminModalAsignaturePlan,
  UploadFile,
  ModalAddComent
};
